import { render } from "./AppLabel.vue?vue&type=template&id=e2e01bbe&scoped=true"
import script from "./AppLabel.vue?vue&type=script&lang=js"
export * from "./AppLabel.vue?vue&type=script&lang=js"

import "./AppLabel.vue?vue&type=style&index=0&id=e2e01bbe&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2e01bbe"]])

export default __exports__